import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
export function OfferBlock() {
  return <section id="offer" className="bg-[#FFF8F0] py-24 px-6" data-id="element-129">
      <div className="max-w-4xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border-2 border-[#2D6A4F]/10 text-center relative overflow-hidden" data-id="element-131">
          {/* Decorative ribbon */}
          <div className="absolute top-6 -right-12 bg-[#E76F51] text-white text-sm font-bold py-1 px-12 transform rotate-45 shadow-md" data-id="element-132">
            OFERTA
          </div>

          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D6A4F] mb-6" data-id="element-133">
            Recupera tus mañanas hoy mismo.
          </h2>

          <p className="text-[#5C4B3A] text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-134">
            Por menos de lo que cuesta un combo de comida rápida, tendrás el
            sistema que te ahorrará cientos de horas de estrés al año.
          </p>

          <div className="mb-10" data-id="element-135">
            <span className="block text-[#5C4B3A] mb-2 uppercase tracking-wider text-sm font-[800]" data-id="element-136">
              Inversión Única
            </span>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-137">
              <span className="text-2xl md:text-3xl text-[#5C4B3A]/50 line-through" data-id="element-138">
                $126.000
              </span>
              <span className="bg-[#E76F51] text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-139">
                -78% OFF
              </span>
            </div>
            <span className="text-5xl md:text-6xl font-bold text-[#2D6A4F]" data-id="element-140">
              $27.000
            </span>
          </div>

          <div className="flex flex-col items-center space-y-4" data-id="element-141">
            <CTAButton href="https://www.imaginovem.com/cart/48473009488122:1" trackEvent="InitiateCheckout" className="w-full md:w-auto text-sm px-10 py-4" data-id="element-142" />

            <div className="flex items-center justify-center space-x-6 text-sm text-[#5C4B3A]/80 mt-6" data-id="element-143">
              <div className="flex items-center" data-id="element-144">
                <LockIcon size={14} className="mr-2 text-[#2D6A4F]" data-id="element-145" />
                Acceso inmediato tras la compra
              </div>
              <div className="flex items-center" data-id="element-146">
                <ShieldCheckIcon size={14} className="mr-2 text-[#2D6A4F]" data-id="element-147" />
                Pago seguro y garantizado
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}